import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mark",
  "use": "icon-mark-usage",
  "viewBox": "0 0 10.391 13.855",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.391 13.855\" id=\"icon-mark\"><defs><style>#icon-mark .a{fill:#666;}</style></defs><path class=\"a\" d=\"M8.159,3.66V15.783l4.33-4.33,4.33,4.33V3.66Zm6.928-1.732H6.427V14.051l.866-.866V2.794h7.794Z\" transform=\"translate(-6.427 -1.928)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol